import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { isAxiosError, ToolDataException, ToolException } from '@/apis/service/exception';
import { Symbols } from '@/symbols';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
let ToolHttp = class ToolHttp extends HttpServiceHelper {
    constructor(httpClient, errorHandlerService) {
        super(errorHandlerService);
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.configErrorHandler();
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(error => {
            if (ToolDataException.is(error)) {
                this._errorDisplayProxy(error.data?.error_msg);
                return true;
            }
            if (!ToolException.is(error)) {
                return false;
            }
            const dashboardError = error.response?.data;
            if (!dashboardError) {
                return false;
            }
            // todo有的错误由前端翻译处理
            this._errorDisplayProxy(JSON.stringify((dashboardError)));
            return true;
        });
    }
    // #endregion
    request(config) {
        config = {
            ...config,
        };
        return this.httpClient(config).then((res) => {
            if (!res.data.status) {
                throw ToolDataException.mark(res);
            }
            return res.data?.data;
        }, error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = ToolException.mark(error);
            throw error;
        });
    }
};
ToolHttp = __decorate([
    injectable(),
    __param(0, inject(Symbols.HttpClient)),
    __param(1, inject(Symbols.ErrorHandlerService)),
    __metadata("design:paramtypes", [Object, Object])
], ToolHttp);
export { ToolHttp };
